import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import moment from 'moment';

import Tag from '../../../../components/V2/Tag';
import { PRODUCT_TEMP } from 'core/assets/images/V2';
import { Text, Box, Button, Flex, Image } from 'core/ui/atoms';

const OrderItem = ({ order }) => {
  const { dummy, date, status } = order || {};

  const orderName = dummy ? 'Signature Program' : 'Order 3875';

  return (
    <ProductContainer>
      <ItemContainer direction='row' justifyContent='start'>
        <SelectCont>
          <ProductImage src={PRODUCT_TEMP} alt={`${orderName} meal program`} />
        </SelectCont>
        <DetailsContainer>
          <ProductName>{orderName}</ProductName>
          <Flex direction='row' justifyContent='space-between' alignItems='center'>
            <SubTitle>{moment(date).format('MMM DD, YYYY')}</SubTitle>
            <Tag text={status} />
          </Flex>
          <ViewDetailsContainer direction='row' justifyContent='space-between'>
            <DetailButton>VIEW DETAILS</DetailButton>
          </ViewDetailsContainer>
        </DetailsContainer>
      </ItemContainer>
    </ProductContainer>
  );
};

OrderItem.propTypes = {
  order: PropTypes.object.isRequired,
};

const ItemContainer = styled(Flex)`
  width: 100%;
`;

const ViewDetailsContainer = styled(Flex)`
  margin-top: 20px;
`;

const DetailButton = styled(Button)`
  text-transform: uppercase;
  text-decoration: underline;
  text-underline-offset: 5px;
  padding: 0;
  margin: 0;
  color: ${(p) => p.theme.colors.primaryV2};
  text-align: center;
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 1.2px;
  text-transform: uppercase;
`;

const SubTitle = styled(Text)`
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  font-size: 12px;
  line-height: 22px;
  margin: 0px;
  color: ${(p) => p.theme.colors.primaryV2};
`;

const ProductImage = styled(Image)`
  height: 94px;
  width: 94px;
  object-fit: cover;
`;

const SelectCont = styled.div`
  position: relative;
  width: 28%;
  display: flex;
  justify-content: end;
  flex-shrink: 0;
  margin-right: 10px;
  &:last-child {
    margin-right: 0;
  }
`;

const ProductContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 44px;
`;

const DetailsContainer = styled(Box)`
  width: 60%;
`;

const ProductName = styled.p`
  font-family: ${({ theme }) => theme.typography.familyLarken};
  font-size: 16px;
  line-height: 22px;
  margin: 0px;
  color: ${(p) => p.theme.colors.primaryV2};
`;

export default OrderItem;
